import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "http://localhost:8080";
const MCP_HEADER = { "X-MCP-Protocol": "1.0" };

const initialForm = {
  propertyId: "",
  type: "IPTU",
  description: "",
  amount: 0,
  dueDate: "",
  provider: "",
  referenceNumber: "",
  notes: "",
};

export default function Bills({ keycloak }) {
  const [bills, setBills] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${keycloak.token}`,
    ...MCP_HEADER,
  };

  const loadBills = async () => {
    const response = await fetch(`${API_URL}/api/bills`, { headers });
    const data = await response.json();
    setBills(data || []);
  };

  useEffect(() => {
    loadBills().catch((error) => console.error("Erro ao carregar contas", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createBill = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/bills`, {
        method: "POST",
        headers,
        body: JSON.stringify(form),
      });
      const created = await response.json();
      setBills((prev) => [created, ...prev]);
      setForm(initialForm);
    } catch (error) {
      console.error("Erro ao criar conta", error);
    } finally {
      setLoading(false);
    }
  };

  const markAsPaid = async (id) => {
    await fetch(`${API_URL}/api/bills/${id}/pay`, {
      method: "PUT",
      headers,
      body: JSON.stringify({ paymentDate: new Date().toISOString().split("T")[0] }),
    });
    loadBills();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "PAGO": return "var(--brand-green)";
      case "VENCIDO": return "#dc2626";
      case "PENDENTE": return "#f59e0b";
      default: return "var(--text-secondary)";
    }
  };

  return (
    <div className="container">
      <section className="hero">
        <h1>Gerenciamento de Contas a Pagar</h1>
        <p>
          Gerencie todas as contas do imóvel: IPTU, condomínio, água, luz, internet e outras despesas.
        </p>
      </section>

      <section className="panel">
        <h2 className="section-title">Nova Conta a Pagar</h2>
        <div className="grid grid-3">
          <input
            placeholder="ID do Imóvel"
            value={form.propertyId}
            onChange={(e) => setForm({ ...form, propertyId: e.target.value })}
          />
          <select
            value={form.type}
            onChange={(e) => setForm({ ...form, type: e.target.value })}
          >
            <option value="IPTU">IPTU</option>
            <option value="CONDOMINIO">Condomínio</option>
            <option value="AGUA">Água</option>
            <option value="LUZ">Luz</option>
            <option value="INTERNET">Internet</option>
            <option value="OUTROS">Outros</option>
          </select>
          <input
            placeholder="Descrição"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <input
            type="number"
            step="0.01"
            placeholder="Valor"
            value={form.amount}
            onChange={(e) => setForm({ ...form, amount: Number(e.target.value) })}
          />
          <input
            type="date"
            placeholder="Data de vencimento"
            value={form.dueDate}
            onChange={(e) => setForm({ ...form, dueDate: e.target.value })}
          />
          <input
            placeholder="Fornecedor"
            value={form.provider}
            onChange={(e) => setForm({ ...form, provider: e.target.value })}
          />
          <input
            placeholder="Número de referência"
            value={form.referenceNumber}
            onChange={(e) => setForm({ ...form, referenceNumber: e.target.value })}
          />
          <textarea
            placeholder="Observações"
            rows={3}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />
        </div>
        <button className="btn-primary" type="button" onClick={createBill} disabled={loading}>
          {loading ? "Salvando..." : "Cadastrar Conta"}
        </button>
      </section>

      <section>
        <h2 className="section-title">Contas Cadastradas</h2>
        <div className="grid grid-3">
          {bills.map((bill) => (
            <div key={bill.id} className="listing-card">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
                <div className="tag">{bill.type}</div>
                <div style={{ 
                  padding: "0.25rem 0.75rem",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  background: getStatusColor(bill.status) + "20",
                  color: getStatusColor(bill.status)
                }}>
                  {bill.status}
                </div>
              </div>
              <h4>{bill.description || bill.type}</h4>
              <div style={{ fontSize: "1.5rem", fontWeight: 700, color: "var(--brand-blue)", margin: "0.75rem 0" }}>
                R$ {bill.amount?.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
              </div>
              <div style={{ color: "var(--text-secondary)", marginBottom: "0.5rem" }}>
                <strong>Imóvel:</strong> {bill.propertyId}
              </div>
              <div style={{ color: "var(--text-secondary)", marginBottom: "0.5rem" }}>
                <strong>Vencimento:</strong> {bill.dueDate}
              </div>
              {bill.provider && (
                <div style={{ color: "var(--text-secondary)", marginBottom: "0.5rem" }}>
                  <strong>Fornecedor:</strong> {bill.provider}
                </div>
              )}
              {bill.status === "PENDENTE" || bill.status === "VENCIDO" ? (
                <button 
                  className="btn-secondary" 
                  onClick={() => markAsPaid(bill.id)}
                  style={{ marginTop: "1rem", width: "100%" }}
                >
                  Marcar como Pago
                </button>
              ) : bill.paymentDate && (
                <div style={{ color: "var(--text-secondary)", fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  Pago em: {bill.paymentDate}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
